export interface AppConfig {
  userPoolId: string;
  clientId: string;
  cognitoDomain: string;
  region: string;
  apiBaseUrl: string;
  redirectUri: string;
}

let cached: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { credentials: 'omit' });
  if (!res.ok) throw new Error(`Failed to load /config.json: ${res.status}`);
  cached = await res.json() as AppConfig;
  return cached;
}

export function getConfig(): AppConfig {
  if (!cached) throw new Error('Config not loaded — call loadConfig() first');
  return cached;
}
